import { OnboardingRouteRedirect } from '../../components';

export default function Step6BudgetRedirect() {
  return <OnboardingRouteRedirect to="/(onboarding)/step-5-budget" />;
}
